import { render, staticRenderFns } from "./approveSet.vue?vue&type=template&id=a251c05e&scoped=true&"
import script from "./approveSet.vue?vue&type=script&lang=js&"
export * from "./approveSet.vue?vue&type=script&lang=js&"
import style0 from "./approveSet.vue?vue&type=style&index=0&id=a251c05e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a251c05e",
  null
  
)

export default component.exports